/**
 * SOLO WAITING (solo_waiting) — brief boot beat. Solo has no "wait for
 * opponents" phase; the server transitions to BETTING the moment the lone
 * player is seated. This just restores a sane baseline so the first betting
 * transition has a clean stage.
 */

import type { GameUpdate } from '@sdl/shared';
import { State } from '../State.js';
import { soloGameSelect } from '../../../../ui/components/SoloGameSelectOverlay.js';
import { soloMultiplayerButton } from '../../../../ui/components/SoloMultiplayerButton.js';
import { soloStacksCounter } from '../../../../ui/components/SoloStacksCounter.js';

export class SoloWaitingState extends State {
  async onEnter(update: GameUpdate): Promise<void> {
    const game = this.game;
    game.ensureShootingView();
    game.playerProfilesOverlay?.show();
    game.playerProfilesOverlay?.setMode('shooting');
    game.countdownOverlay?.stop();
    game.bettingHUD3D?.setLockInVisible(false);
    game.instructionBanner?.hide();
    game.cameraController?.setMode('default');
    game.clearResultDedup();
    this._updateProfiles(update);

    // Game picker (shooting view, no dice). Selecting sends solo:set_mode,
    // which the server uses to set the mode and transition into BETTING.
    // While it's up, fade the TABLES pill + winnings counter — the modal's
    // chrome (close button top-right) occupies the same corners.
    soloMultiplayerButton.setSuppressed(true);
    soloStacksCounter.setSuppressed(true);
    soloGameSelect.show((mode) => {
      game.networkManager.sendSoloMode(mode);
    });
  }

  async onUpdate(update: GameUpdate): Promise<void> {
    this._updateProfiles(update);
  }

  async onExit(_update: GameUpdate): Promise<void> {
    soloGameSelect.hide();
    soloMultiplayerButton.setSuppressed(false);
    soloStacksCounter.setSuppressed(false);
  }
}
